import Vue from 'vue'
import Router from 'vue-router'
import Store from '../store'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import( '../components/SRSParts/SubComponents/Login.vue' ),
    meta: {
      name: 'name',
      isPublic: true,
      isAllowUpdate: true,
      allowAccessFromOtherSite: false
    }
  }, 
  {
    path: '/menu',
    name: 'MenuDialog',
    component: () => import( '../components/SRSParts/SubComponents/Menu.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowAccessFromOtherSite: false
    }
  },
  {
    path: '/planview',
    name: 'PlanView',
    component: () => import( '../components/SRSParts/SubComponents/PlanView.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowAccessFromOtherSite: false
    }
  },
  {
    path: '/newplan',
    name: 'New Plan',
    component: () => import( '../components/SRSParts/SubComponents/newplan.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowAccessFromOtherSite: false
    }
  },
  {
    path: '/existing',
    name: 'Existing',
    component: () => import( '../components/SRSParts/SubComponents/ExistingPlan.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowAccessFromOtherSite: true
    }
  },
  {
    path: '/gaibulist',
    name: 'GaibuList',
    component: () => import( '../components/SRSParts/Sheets/Gaibu.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowConfirmDialog: true,
      allowAccessFromOtherSite: false,
    }
  },
  {
    path: '/setsubisheet',
    name: 'SetsubiSheet',
    component: () => import( '../components/SRSParts/Sheets/Setsubi.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowConfirmDialog: true,
      allowAccessFromOtherSite: false
    }
  },
  {
    path: '/basicspecs',
    name: 'BasicSpecs',
    component: () => import( '../components/SRSParts/Sheets/Kihon.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowConfirmDialog: true,
      allowAccessFromOtherSite: false
    }
  },
  // {
  //   path: '/kaitouhyogaibu',
  //   name: 'KaitouhyoGaibu',
  //   component: () => import( '../components/SRSParts/Table/Sheet.vue' ),
  //   meta: {
  //     isPublic: false,
  //     isAllowUpdate: false,
  //     allowConfirmDialog: true
  //   }
  // },
  // {
  //   path: '/kaitouhyosetsubi',
  //   name: 'KaitouhyoSetsubi',
  //   component: () => import( '../components/SRSParts/SubComponents/Menu.vue' ),
  //   meta: {
  //     isPublic: false,
  //     isAllowUpdate: false,
  //     allowConfirmDialog: true,
  //     allowAccessFromOtherSite: false
  //   }
  // },
  {
    path: '/summary',
    name: 'Summary',
    component: () => import( '../components/SRSParts/SubComponents/Summary.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowConfirmDialog: true,
      allowAccessFromOtherSite: false
    }
  },
  {
    path: '/changeconfirmation',
    name: 'ChangeConfirmation',
    component: () => import( '../components/SRSParts/SubComponents/ChangeConfirmation.vue' ),
    meta: {
      isPublic: true,
      isAllowUpdate: false,
      allowAccessFromOtherSite: false
      //allowConfirmDialog: true
    }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import( '../components/SRSParts/SubComponents/Feedback.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowConfirmDialog: true,
      allowAccessFromOtherSite: false
    }
  },
  {
    path: '/acceptredirect/:email/:username/:constructioncode/:plannumber/:housetypeid/:key/:uniqueid',
    name: 'AcceptRedirect',
    component: () => import( '../components/SRSParts/SubComponents/AcceptRedirect.vue' ),
    meta: {
      isPublic: false,
      isAllowUpdate: false,
      allowConfirmDialog: true,
      allowAccessFromOtherSite: true
    }
  },
];

const router = new Router({
  mode: 'history',
  base: process.env.MIX_API_BASEURL,
  routes
})



//loop and check each route and check if already logged or not
router.beforeEach( async ( to, from, next) => {
    if (performance.memory) {
      //reset if increase memory usage 2024-10-17 jazz
      // if( (to.name === 'MenuDialog' && from.name != null) && (Math.floor(performance.memory.usedJSHeapSize / (1024 * 1024)) )  >  300 ){
      //    //await new Promise(r => setTimeout(r, 3000));
      //    window.location.replace('menu')
      // }
 
      //2025-09-10 jazz, only crs open allowed, set in .env 
      //2025-11-14 jazz, add bypass     
      if(process.env.MIX_ALLOW_ONLY_CRS_OPEN == 1 && (router.history._startLocation !== `/${process.env.MIX_BYPASS_CODE}` && process.env.MIX_DEPLOYMENT == 'ichijo')){
          if(!router.history._startLocation.includes('acceptredirect') ){
              await new Promise(r => setTimeout(r, 300));
              
              //Modified 2025-12-03 jazz, 
              if( (router.history._startLocation === '/' || router.history._startLocation === '/login') || !Store.state.UserInfo.isLogged ){
                  Store.dispatch('BypassOn', false);
                  alert('WARNING!!!\nOnly open this app from the CAD Request System')
                  await new Promise(r => setTimeout(r, 100));
                  window.location.replace('about:blank')
              }
          }
      }

      //2025-05-20 jazz, clear memory when reaches greater than 200 mb
      console.log('Javascript used heap size: => ' + Math.floor(performance.memory.usedJSHeapSize / (1024 * 1024)) + ' MB') 
      
      if( (to.name === 'MenuDialog' && from.name != null) && (Math.floor(performance.memory.usedJSHeapSize / (1024 * 1024)) )  >  400 ){
          await new Promise(r => setTimeout(r, 500)); //2025-07-10 jazz, free mem
 
          window.location.replace('menu')
      }

      if ( process.env.MIX_ENVIRONMENT === 'hrd' ) {
        // console.log('----------------');
        // console.log(from.name)
        // console.log('Total JS Heap Size: ' + Math.floor(performance.memory.totalJSHeapSize / (1024 * 1024)) + ' MB');
        // console.log('Used JS Heap Size: ' + Math.floor(performance.memory.usedJSHeapSize / (1024 * 1024)) + ' MB');
        // console.log('JS Heap Size Limit: ' + Math.floor(performance.memory.jsHeapSizeLimit / (1024 * 1024)) + ' MB');
      }
    }

    if(Store.state.UserInterface.IsSheetItemsCountModified){
      Store.dispatch('IsSheetItemsCountModified', false)
    }

    if( from.name != null || to.meta.isPublic){
        // SRSFunc.SRSDefaults.showConfirmDialog(true, '表示されているデータを保存しないで<p>移動または終了します。よろしいですか？', 310)

        if( Store.state.UserInfo.isLogged == false && to.meta.isPublic == false){
            window.location.reload(`${process.env.MIX_API_BASEURL}/login`)
        }else{
            next()
        }
    }else{
        if(Store.state.UserInfo.isLogged){
            if(to.meta.allowAccessFromOtherSite){
                if(to.params.key === process.env.MIX_API_KEY){
                    const tmpObj = {
                        userName: `Welcome  ${to.params.username}!`,
                        fullName: to.params.email,
                        Browser: '--',
                        isLogged: true
                    }

                    Store.dispatch('setUserInfo', tmpObj) 
                    Store.dispatch('isLogged', true)
                }
            }

            next()
        }else{
            if(to.meta.allowAccessFromOtherSite){
                if(to.params.key === process.env.MIX_API_KEY){ //check if the redirect is from valid site
      
                    const tmpObj = {
                        userName: `Welcome  ${to.params.username}!`,
                        fullName: to.params.email,
                        Browser: '--',
                        isLogged: true
                    }

                    Store.dispatch('setUserInfo', tmpObj) 
                    Store.dispatch('isLogged', true)
                    next()
                }else{
                    next('/login')
                }
            }else{
                next('/login')
            }
        }
    }

});

export default router
